import { render, staticRenderFns } from "./PlatInfo.vue?vue&type=template&id=466986ec"
import script from "./PlatInfo.vue?vue&type=script&lang=js"
export * from "./PlatInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports